const CasteOptions = [
    { value: 'SC', label: 'SC' },
    { value: 'ST', label: 'ST' },
    { value: 'OBC', label: 'OBC' },
    { value: 'GEN', label: 'General' },
  ];
  
  export default CasteOptions;